"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaults_1 = require("./defaults");
const eventService_1 = require("./eventService");
class Analytics {
    configure(config) {
        const { consumerKey, apiKey, entityKey = '', endpoint = defaults_1.default.endpoint, } = config;
        this.config = {
            consumerKey,
            apiKey,
            entityKey,
            endpoint,
        };
    }
    send(action, payload = {}, correlationKey = '', schema = '', createdAt) {
        const event = {
            action,
            payload,
            schema,
        };
        if (!this.config) {
            throw new Error(`configure() must be called before events can be sent.`);
        }
        return eventService_1.default.post(this.config, event, correlationKey, createdAt);
    }
}
exports.default = Analytics;
